import React from "react";
import { siteContent } from "../content";
import Section from "../components/Section";
import ArtistCard from "../components/ArtistCard";

export default function Artists() {
  const { artists, socials } = siteContent;

  return (
    <div className="space-y-6">
      <Section
        eyebrow="Artists"
        title="The voices behind the magic"
        description="From playback singing to viral live sessions, meet the duo whose performances captivate audiences everywhere."
      >
        <div className="grid gap-6 md:grid-cols-2">
          {artists.map((artist) => (
            <ArtistCard key={artist.name} artist={artist} socials={socials} />
          ))}
        </div>
      </Section>
    </div>
  );
}
